const SERVICE = 'coupon-service'

const getCouponListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/admin/coupon', params)

const getCouponApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/admin/coupon/${id}`)

const createCouponApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/coupon')

const updateCouponApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/coupon/${id}`)

const deleteCouponApi = async (api, id) => api
  .setMethod()
  .delete()
  .setService(SERVICE)
  .process(`/admin/coupon/${id}`)


const postCouponApplyApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/apply')

module.exports = {
  getCouponListApi,
  getCouponApi,
  createCouponApi,
  updateCouponApi,
  deleteCouponApi,
  postCouponApplyApi,
}
